import PropTypes from 'prop-types';

const notificationTemplatePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  useDefaultEmailTemplate: PropTypes.bool,
  useDefaultSmsTemplate: PropTypes.bool,
  triggeredEmailSubject: PropTypes.string,
  triggeredEmailBody: PropTypes.string,
  triggeredSmsBody: PropTypes.string,
  clearedEmailSubject: PropTypes.string,
  clearedEmailBody: PropTypes.string,
  clearedSmsBody: PropTypes.string,
  // uniqueAlertCount: PropTypes.number,
});

export default { notificationTemplatePropType };
